<template>
  <div class="bg">
    <home-firm-banner></home-firm-banner>
    <home-firm-content :isLeft=true title="企业文化" desc="　　北京木联电子商务有限公司成立于2016年2月，投资2000万元开发运营“木材码头APP”项目。以木材、企业、用户为端口的电商平台，围绕木材核心业务及电商体系结构，以及便捷的运输服务、供货信息、网络安全等业务和智能终端业务完整的商业生态圈相结合。以数据和流量共享为核心，以营销服务和云服务为基础，有效整合木材行业大数据的电商平台。"></home-firm-content>
    <home-firm-content :isLeft=true title="业务网络" desc="　　木材码头已整合了北京、天津、青岛、广东、满洲里、二连浩特、绥芬河、沈阳、西安等各地区的龙头贸易港口资源，形成覆盖大中华区的综合销售网络。聚合了5000多家供应商和上万家终端用户资源，服务覆盖全国24个主要口岸和151个内陆县市，日交易流水近千万元，平台企业年纳税总额将超10亿元人民币。"></home-firm-content>
    <home-firm-content title="愿景与使命" desc="合作共赢——为用户提供持续的有价值服务；
    开拓创新——为国家宏观调控提供理论依据；
    务实高效——为行业资源管理提供数据支撑；
    服务为本——打造全球专业木材全产业链综合服务平台；"></home-firm-content>
    <div class="img-container mart80">
    <img src="/static/img/firm_intro/develop.png"/>
    </div>
  </div>
</template>

<script>
  import HomeFirmContent from './HomeFirmContent'
  import HomeFirmBanner from './HomeFirmBanner'
  export default {
    components: {HomeFirmBanner, HomeFirmContent},
    name: 'homeFirmIntro'
  }
</script>

<style scoped>
  bg {
    display: flex;
  }
  .img-container {
    margin: auto;
  }
  .mart80{
    margin-top: 80px;
  }
  img {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// HomeFirmIntro.vue?7be1b08c